<template>
  <div
    class="dropdown p-absolute"
    :class="{ 'dropdown--visible': isVisible }"
  >
    <ul class="dropdown__list">
      <li
        v-for="option in optionList"
        :key="option.id"
        class="dropdown__item"
        :class="[option.additionalClasses ?? '']"
      >
        <component
          :is="option.route ? 'router-link' : 'a'"
          :to="option.route || null"
          class="dropdown__link d-block cursor-pointer"
          @click.prevent="option.action() || null"
        >
          {{ option.label }}
        </component>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DropDownList',

  props: {
    optionList: {
      type: Array,
      default: () => []
    },

    isVisible: {
      type: Boolean,
      default: () => true
    }
  }
})
</script>

<style lang="scss" scoped>
  .dropdown {
    z-index: 999;
    top: 50%;
    right: 30px;

    width: 265px;
    height: auto;
    padding: 6px 0;
    border-radius: 8px;
    background-color: rgb(var(--gray5));
    box-shadow: 0 0 38px 5px rgba(var(--black), 0.1);

    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    transition: opacity .4s ease-in-out, transform .4s ease-in-out, visibility 0s .4s;

    &--visible {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
      transition: opacity .4s ease-in-out, transform .4s ease-in-out, visibility 0s;
    }

    &__item {
      &--erasable a {
        color: var(--error1);
      }
    }

    &__link {
      padding: 8px 25px;
      transition: .2s ease-in-out;

      color: rgb(var(--white));
      font: 500 1.2rem "Nunito", sans-serif;

      &:hover {
        opacity: .7;
      }
    }
  }
</style>
